import { Block, component } from '../../../scripts/core/Component'
import { Form } from '../../ui/form/index'
import 'whatwg-fetch'
import { Button } from '../../ui/button/index'

@component('feedbackForm')
class FeedbackForm extends Block {
  constructor (context) {
    super(context)

    this._successHandlers = []
    this._failureHandlers = []

    this.formList = this.list(Form)
    this.formList.forEach(
      (form) => form.el.addEventListener('submit', (e) => {
        e.preventDefault()
        this.submit(form)
      })
    )
    
    this.submitButton = this.list(Button).filter((button) => (button.el.getAttribute('type') === 'submit'))
  }
  
  disableSubmit() {
    this.submitButton.forEach((button) => {
      button.disable()
    })
  }
  
  enableSubmit() {
    this.submitButton.forEach((button) => {
      button.enable()
    })
  }

  submit(form) {
    this.disableSubmit()
    
    form.submit()
      .then((data) => {
        this._successHandlers.forEach((handler) => {
          handler.apply(this, data)
        })
        
        form.reset()
        this.enableSubmit()
      })
      .catch((error) => {
        console.log(error)
      
        this._failureHandlers.forEach((handler) => {
          handler.apply(this, error)
        })

        this.enableSubmit()
      })
  }

  onSuccess(handler) {
    if(typeof handler !== 'function') return
    this._successHandlers.push(handler)
  }

  onFailure(handler) {
    if(typeof handler !== 'function') return
    this._failureHandlers.push(handler)
  }
}

export {
  FeedbackForm
}


// WEBPACK FOOTER //
// ./components/main/feedbackForm/index.js